<template>
  <v-container fluid>
    <v-row no-gutters align="center">
    <h2 class="text-h4">{{$t('companies.title')}}</h2><v-spacer/>
    <action-button to="/add-company" icon="$add" :tooltip="$t('companies.add.action')" color="success" fab small dark />
    </v-row>
    <v-row id="pfid1618854588" v-if="list && list.length">
      <v-col xs="12" md="6" lg="4" xl="3" v-for="c in list" :key="c.id">
    <v-card  :to="`/companies/${c.id}`" :color="getStatus(c).color.replace('success','primary')">
      <v-card-title><v-icon dark left>$company</v-icon><span style="width: 85%" class="white--text overflow-hidden text-no-wrap">{{ c.name }}</span></v-card-title>
      <v-list>
        <v-list-item>
              <v-list-item-icon>
                <v-icon :color="getStatus(c).color">{{
                  getStatus(c).icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>{{$t('domains.status.title')}}</v-list-item-subtitle>
                <v-list-item-title>{{ getStatus(c).text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="isOwner({ item: c })">
                <action-button v-if="c.active == 'PAYMENT_DUE'" :tooltip="$t('companies.reviewPaymentInfo')" :to="{ name: 'billing', params: {company: c.id} }" icon="$billing" />
                <action-button v-else-if="c.active == 'OVER_LIMIT'" :tooltip="$t('companies.selectPlan')" :to="{ name: 'plan', params: {company: c.id} }" icon="$plan" />
              </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon><v-icon>$address</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('companies.address')}}</v-list-item-title>
            <v-list-item-subtitle>{{ formatAddress(c) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon><v-icon>$country</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('companies.country')}}</v-list-item-title>
            <v-list-item-subtitle>{{ formatCountry(c.country) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon><v-icon>$plan</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('companies.visitors')}}</v-list-item-title>
            <v-list-item-subtitle><span :class="getVisitorsColor(c.stats.monthlyUsers, c.activeSubscription ? c.activeSubscription.monthlyUserLimit : null)">{{c.stats.monthlyUsers}}</span> / {{ (c.activeSubscription ? c.activeSubscription.monthlyUserLimit : null) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon><v-icon>$subscription</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('companies.subscription')}}</v-list-item-title>
            <v-list-item-subtitle>{{ formatDate(c.activeSubscription ? c.activeSubscription.to : null, true) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <!-- mixing data from projects with multiple currencies -->
        <!--
        <v-list-item v-if="c.activeSubscription">
          <v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{$t('companies.sales', { date: formatDate(c.activeSubscription.from, true)})}}</v-list-item-title>
            <v-list-item-subtitle>{{ formatNumber(c.stats.dreamroiSales,0) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        -->
      </v-list>
      
    </v-card>
      </v-col>
    </v-row>
    <v-row v-else-if="list">
      <v-alert 
      type="success" 
      border="left" 
      class="mt-5"
      width="100%"
      colored-border
      >{{$t('companies.emptyList')}}</v-alert>
    </v-row>
    <v-row v-else>
      <v-col xs="12" md="4" lg="3" xl="2" v-for="(n,i) in Array(12)" :key="i">
      <v-card><v-skeleton-loader type="card-heading, list-item-avatar@4" /></v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import Formatters from "@/mixins/formatters"
  import Countries from "@/mixins/countries"
  import DomainStatus from "@/mixins/domain-status"

  export default {
    name: 'Companies',
    mixins: [Formatters, Countries, DomainStatus ],
    data() {
      return {
      }
    },
    computed: {
      ...mapState('companies', ['list' /*, 'item'*/]),
      ...mapGetters('auth', ['isOwner'])
    },
    methods: {
    },
    watch: {
      list() {
        if(this.list && this.list.length == 0) {
          this.$router.push('/add-company');
        }
      }
    },
    created() {
      this.$store.dispatch('companies/list');
    }
  }
</script>
